export function mergeInvoiceSplitCharges(allEntities, splitCharges) {
  const source = Array.isArray(allEntities) ? allEntities : []
  const updates = Array.isArray(splitCharges) ? splitCharges : []
  const updateMap = new Map()
  const appended = []

  updates.forEach(charge => {
    if (charge && charge.uuid) {
      updateMap.set(charge.uuid, charge)
    }
  })

  const merged = source.map(item => {
    if (item && item.uuid && updateMap.has(item.uuid)) {
      const update = updateMap.get(item.uuid)
      updateMap.delete(item.uuid)
      return Object.assign({}, item, update)
    }
    return item
  })

  updates.forEach(charge => {
    if (!charge) return
    const existsInSource = source.some(item => item && item.uuid && item.uuid === charge.uuid)
    if (!existsInSource) {
      appended.push(charge)
    }
  })

  return merged.concat(appended)
}
